import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import {DepartContext} from "../depart/context/DepartContext";

const DepartAlertView = () => {
    const {viewModel, dispatch} = useContext(DepartContext)
    const removeNotification = () => {
        dispatch({ type: 'REMOVE_NOTIFICATION'});
    }

    return (
        <div>
            {viewModel.alert.title ?
                <Row widths={["grid-8"]} spacingInset="large large none" alignmentHorizontal="center">
                    <Alert onClose={() => removeNotification()}
                           size="medium" type={viewModel.alert.type}>{viewModel.alert.title}</Alert>
                </Row>
                : null}
        </div>
    )
}

export default DepartAlertView


// WEBPACK FOOTER //
// ./src/components/alert/DepartAlertView.js